import { render, staticRenderFns } from "./TitlePie.vue?vue&type=template&id=9a2f7a2a"
import script from "./TitlePie.vue?vue&type=script&lang=js"
export * from "./TitlePie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports